export default "__VITE_PUBLIC_ASSET__653f7e80__"